import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
import { TransactionUnitPriceSource } from '../constants/transaction';
import { ITransactionUnitPrice, TransactionUnitPriceType } from '../interface/transaction';

interface ITransactionUnitPriceParameters {
  userId?: string;
  matterId?: string;
  transactionTypeId?: string;
  unitId?: string;
  transactionDate?: string;
  enabled?: boolean;
}
export const useFetchTransactionUnitPrice = (params: ITransactionUnitPriceParameters) => {
  const { enabled, ...rest } = params;
  const queryString = toQueryString(rest as unknown as QueryParamObject);
  const url = queryString
    ? `${API_URLS.TRANSACTION_UNIT_PRICE}?${queryString}`
    : API_URLS.TRANSACTION_UNIT_PRICE;

  const canFetchUnitPrice =
    !!params.matterId && !!params.userId && !!(params.transactionTypeId || params.unitId);

  const emptyUnitPrice: ITransactionUnitPrice = {
    unitPrice: 0,
    units: 0,
    source: TransactionUnitPriceSource.NOT_SET,
    type: TransactionUnitPriceType.UNKNOWN,
    otherInfo: '',
  };

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['transaction-unit-price', rest],
    queryFn: () => {
      if (!canFetchUnitPrice) {
        return emptyUnitPrice;
      }
      return get(url);
    },
    enabled: !!enabled,
  });

  return { data: error ? undefined : (data ?? null), isLoading, error, refetch };
};
